class Modal {
	constructor({ modalId, trigger }) {
		console.log(modalId);
		this.modal = document.querySelector(modalId);
		this.trigger = trigger || '.modal-trigger';
		this.modalClose = this.modal.querySelector('.modal__close');
		this.modalContent = this.modal.querySelector('.modal__content');
		this.modalWrapper = this.modal.querySelector('.modal__wrapper');
		this.modalOverlay = this.modal.querySelector('.modal__overlay');
		this.modalBody = this.modal.querySelector('.modal__body');
		this.modalTrigger = document.querySelectorAll(this.trigger);
		this.toggled = false;
		this.useHash = this.modal.dataset.useHash || true;
	}

	init() {
		console.log('modal init');
		this.addEventListeners();
		if (this.useHash) {
			// this.checkHash();
		}
	}

	checkHash() {
		const hash = window.location.hash.substring(1);
		if (!hash) return;
		// Open the modal
		this.openModal();
	}

	addEventListeners() {
		this.modalTrigger.forEach(trigger => {
			if (trigger.dataset.modal !== this.modal.id) return;
			// console.log(trigger);
			// trigger.querySelector('a').addEventListener('click', e => {
			// 	console.log('clicked');
			// 	e.preventDefault();
			// 	this.openModal(e.target);
			// });
			trigger.addEventListener('click', e => {
				// Check if the trigger has an anchor tag child
				if (e.target.tagName === 'A') {
					// Disable the default behavior of the anchor tag
					e.preventDefault();
				}

				e.preventDefault();
				this.openModal(e.target);
			});
		});
		this.modalClose.addEventListener('click', () => {
			this.closeModal();
		});
		this.modalOverlay.addEventListener('click', e => {
			if (e.target === this.modalOverlay) {
				this.closeModal();
			}
		});
		// window.addEventListener('resize', () => {
		// 	this.checkModalBodyHeight();
		// 	this.resizeModalBody();
		// });
	}

	// If the height of the content is greater than the height of the viewport, add a class to the modal body to allow scrolling
	checkModalBodyHeight() {
		if (this.modalContent.offsetHeight > window.innerHeight) {
			this.modalBody.classList.add('modal__body--scrollable');
			this.resizeModalBody();
		} else {
			this.modalBody.style.height = 'auto';
			this.modalBody.classList.remove('modal__body--scrollable');
		}
	}

	resizeModalBody() {
		if (this.toggled) {
			// Make the modalBody 90% of the viewport height
			this.modalBody.style.height = `${window.innerHeight * 0.9}px`;
		}
	}

	openModal(target) {
		this.modal.classList.add('modal--open');
		document.body.classList.add('modal-open');
		this.toggled = true;
		setTimeout(() => {
			this.modalOverlay.style.opacity = 1;
		}, 50);
		setTimeout(() => {
			this.checkModalBodyHeight();
		}, 500);
	}
	closeModal() {
		this.modalOverlay.style.opacity = 0;
		document.body.classList.remove('modal-open');
		this.toggled = false;
		setTimeout(() => {
			this.modal.classList.remove('modal--open');
			this.checkModalBodyHeight();
		}, 1000);
	}
}

const modals = document.querySelectorAll('.modal');
modals.forEach(modal => {
	const modalId = modal.getAttribute('id');
	let trigger = modal.dataset.trigger || 'modal-trigger';
	new Modal({
		modalId: `#${modalId}`,
		trigger: `.${trigger}`,
	}).init();
});
